import { COLORS } from './chartColors';
import { SelectedEntity } from './helpers/types';

interface SourceTypeRecord {
  source_type: string;
}

interface SourceTypeData {
  data:
    | {
        reportNotFound: boolean;
      }
    | SourceTypeRecord[];
}

export const applicationCountSourceTypeTransformer = (
  data: Record<string, SourceTypeData>,
  selectedEntities: SelectedEntity[]
) => {
  // Flatten all records and filter by selected entities
  const allRecords: SourceTypeRecord[] = [];
  Object.entries(data).forEach(([key, value]) => {
    const [entity_id] = key.split('_');
    const isAllSelected = selectedEntities?.some((entity: SelectedEntity) => entity.name === 'All');
    const isEntitySelected = selectedEntities?.some(
      (entity: SelectedEntity) => entity.id.toString() === entity_id
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        allRecords.push(record);
      });
    }
  });

  // Group by source_type
  const sourceTypeCounts: Record<string, number> = {};
  allRecords.forEach((record) => {
    const type = record.source_type || 'Unknown';
    sourceTypeCounts[type] = (sourceTypeCounts[type] || 0) + 1;
  });

  return {
    labels: Object.keys(sourceTypeCounts),
    datasets: [
      {
        data: Object.values(sourceTypeCounts),
        borderWidth: 1,
        backgroundColor: COLORS.slice(0, Object.keys(sourceTypeCounts).length)
      }
    ]
  };
};
